import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	projectKey: string,
	accountId: string, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any /* Observable<SummaryRunAsUserSettings> */ => {
	const runAsUserData = {
		type: 'specificUser',
		user: {
			accountId,
		},
	};

	return fetchJson$(`${baseUrl}/rest/servicedesk/automation/1/project/${projectKey}/runAsUser`, {
		method: 'PUT',
		body: JSON.stringify(runAsUserData),
	});
};
